import truncate from 'lodash/fp/truncate'
import { DateUtil } from '@utils/dateUtil'

const truncateFilename = (filename: string, updatedAt: string): string => {
  const updatedTime = DateUtil(updatedAt).timeFormat()
  const fileExtension = getFileExtension(filename)
  const filenameWithoutExtension = (filename.substr(0, filename.lastIndexOf('.')) || filename) + ' '
  const truncatedFilename = truncate10Symbols(filenameWithoutExtension)

  return `${truncatedFilename}${updatedTime}.${fileExtension}`
}

const truncate10Symbols = truncate({
  length: 10,
})

export const getFileExtension = (fileName: string) => fileName.match(/[^\\]*\.(\w+)$/)?.[1] || ''

export default truncateFilename
